export const hi_HI_vyavhaar = [
  {
    slug: 'front-cover',
    name: 'मुखपृष्ठ (Front Cover)',
    markdown: `
<div style="position: relative; height: 100vh; background-image: url('https://wallpapers.com/images/hd/book-cover-background-rjiqduzo558351qs.jpg'); background-size: cover; background-position: center; display: flex; flex-direction: column; justify-content: space-between; color: white; text-align: center; padding: 20px; box-sizing: border-box;page-break-after: always;">

<div style="margin-top: 10px;  background-color: rgba(0,0,0,0.4)">
  <h1 style="font-size: 40px; font-weight: bold; text-shadow: 4px 4px 8px rgba(0,0,0,0.9); color: #8B0000;">हमारा व्यवहार</h1>
  <h2 style="font-size: 30px; margin-top: 20px; text-shadow: 3px 3px 6px rgba(0,0,0,0.8); color: #8B0000;">एक मनोवैज्ञानिक-सामाजिक विश्लेषण</h2>
</div>

<div style="margin-bottom: 10px;">
  <h3 style="font-size: 30px; text-shadow: 2px 2px 4px rgba(0,0,0,0.7);">प्रो. शमशाद हुसैन</h3>
  <p style="font-size: 16px; text-shadow: 2px 2px 4px rgba(0,0,0,0.7);">(अनुवादक: ज़किया मशहदी)</p>
</div>

<div style="align-self: center; background-color: rgba(0,0,0,0.4); padding: 0px; border-radius: 10px;">
  <h4 style="font-size: 16px; color: gold; text-shadow: 2px 2px 4px rgba(0,0,0,0.9);">सुब्हा बृन्दा ओरिएण्टल पब्लिक लाइब्रेरी, पटना</h4>
</div>
</div>

`,
  },
  {
    slug: 'back-cover',
    name: 'पृष्ठ पृष्ठ (Back Cover)',
    markdown: `
<div style="text-align: center; height: 100vh; background-image: url('https://static.vecteezy.com/system/resources/previews/055/712/427/non_2x/set-of-colorful-abstract-background-for-your-cover-design-book-cover-flyer-brochure-banner-poster-annual-report-and-more-abstract-landscape-background-vector.jpg'); background-size: cover; background-position: center; display: flex; flex-direction: column; justify-content: center; color: white; text-shadow: 2px 2px 4px rgba(0,0,0,0.7); padding: 20px;page-break-after: always;">

# पुस्तक का सारांश

यह पुस्तक आपके विषय के बारे में एक रोचक और गहन चर्चा प्रस्तुत करती है। यहां एक आकर्षक विवरण लिखें जो पाठक को पुस्तक खरीदने के लिए प्रेरित करे।

**लेखक:** लेखक का नाम  
**प्रकाशक:** प्रकाशक का नाम  
**ISBN:** 978-3-16-148410-0  
**मूल्य:** ₹४९९

</div>

(बैकग्राउंड इमेज को अपनी इमेज से बदलें।)
`,
  },
  {
    slug: 'dedication',
    name: 'समर्पण (Dedication)',
    markdown: `
<div style="height: 100vh; background-size: cover; background-position: center; display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 10px; text-align: center; color: black; font-size: 18px; line-height: 1.8;page-break-after: always;">

<h1 style="font-size: 48px; margin-bottom: 80px;">समर्पण</h1>

अपनी जीवन संगिनी निशात आबिदीन के नाम<br>
जिन्होंने न केवल मुझे समझा<br>
बल्कि<br>
दूसरों को समझने में मेरी मदद भी की

</div>

<hr style="page-break-after: always;" />

`,
  },
  {
    slug: 'author-intro',
    name: 'लेखक परिचय (Author Introduction)',
    markdown: `
# डा. शमशाद हुसैन - एक परिचय

डा. शमशाद हुसैन (जन्म 1940) ने मनोविज्ञान में एम.ए. और पी एच.डी. की डिग्रियाँ क्रमशः 1960 और 1969 में प्राप्त कीं। अभी वह मगध विश्वविद्यालय के कुलपति के पद पर आसीन हैं। इससे पहले वह नालन्दा खुला विश्वविद्यालय के उपकुलपति का कार्यभार संभाल रहे थे। वह पटना विश्वविद्यालय के मनोविज्ञान विभाग में प्रोफ़ेसर और विभागाध्यक्ष के रूप में काम कर चुके हैं। इसी विश्वविद्यालय के मनोवैज्ञानिक शोध एवं सेवा संस्थान (Institute of Psychological Research and Services) और दूर-शिक्षा निदेशालय में निदेशक की ज़िम्मेदारियाँ संभाल चुके हैं। पटना विश्वविद्यालय रोज़गार सूचना तथा मार्ग दर्शन के मुख्य पदाधिकारी रह चुके हैं। यू.जी.सी. द्वारा प्रायोजित अल्पसंख्यक कोचिंग सेन्टर में निदेशक की कर्तव्यों का निर्वाह कर चुके हैं। पटना विश्वविद्यालय सिन्डिकेट में शिक्षा विद की हैसियत से कुलपति के प्रतिनिधि के रूप में सम्बद्ध हैं। यू.जी.सी. स्टैन्डिंग कमिटी ऑन कोरस्पॉन्डेन्स कोर्सेज (U.G.C. Standing Committee on Correspondence Courses – 1995) के सदस्य रहे हैं। विकलांग व्यक्तियों के लिए परामर्शदात्री समिति, भारत सरकार के सदस्य मनोनीत किए जा चुके हैं। इन्हें बायोग्राफ़िकल सेन्टर, इंग्लैण्ड ने “मैन ऑफ़ द इयर” की उपाधि के लिए मनोनीत किया और अमरीकन बायोग्राफ़िकल इंस्टीट्यूट, यू.एस.ए. ने 1993, 1994 और 1995 में यह उपाधि प्रदान की। इन्हें नई दिल्ली से विजय श्री पुरस्कार प्राप्त हुआ। 1997 में इन्हें मलेशिया के अंतर्राष्ट्रीय इस्लामिक विश्वविद्यालय के रामर्श एवं मनोचिकित्सा पर होने वाले अंतर्राष्ट्रीय सेमिनार के एक तकनीकी सत्र की अध्यक्षता के लिए आमंत्रित किया गया। दूर शिक्षा के निदेशकों और उपकुलपतियों के एक अंतर्राष्ट्रीय इस्लामिक विश्व विद्यालय के परामर्श एवं मनोचिकित्सा पर होने वाले अंतर्राष्ट्रीय सेमिनार के एक तकनीकी सत्र की अध्यक्षता के लिए आमंत्रित किया गया।

<hr style="page-break-after: always;" />

`,
  },
  {
    slug: 'title-page',
    name: 'शीर्षक पृष्ठ (Title Page)',
    markdown: `
<p style="font-size: 30px;text-align: center; margin-bottom: 10px;font-weight: bold;">हमारा व्यवहार</h1>
<p style="font-size: 30px;text-align: center; margin-bottom: 100px;font-weight: bold;">एक मनोवैज्ञानिक-सामाजिक विश्लेषण</h2>
<div style="text-align: center">
<h3 style="font-size: 40px;">प्रो. शमशाद हुसैन</h3>
<p style="font-size: 28px;">प्रोफ़ेसर एमेरिटस, पटना विश्वविद्यालय</p>
<p style="font-size: 28px;">(अनुवादक : ज़किया मशहदी)</p>
</div>

<div style="margin-top: 150px;text-align: center">
  <h4 style="font-size: 20px;">खुदा बख्श ओरिएंटल पब्लिक लाइब्रेरी, पटना</h4>
</div>
<hr style="page-break-after: always;" />

`,
  },
  {
    slug: 'table-of-contents-1',
    name: 'विषय सूची - भाग १ (Table of Contents Part 1)',
    markdown: `

    <h1 style="text-align: center; 
    font-size: 12px;">विषय सूची</h1>
  
  <table style="width: 100%; 
    font-size: 12px; overflow: hidden; box-shadow: 0 4px 15px rgba(0,0,0,0.15);">
  
  <thead>
    <tr style="background-color: #2c3e50; color: white;">
      <th style="text-align: center;">अध्याय</th>
      <th style="text-align: center;">विषय</th>
      <th style="text-align: center; width: 15%;">पृष्ठ संख्या</th>
    </tr>
  </thead>
  
  <tbody>
  
  <tr style="">
    <td style=" text-align: center;">1</td>
    <td style="">हमारा व्यवहार - एक अन्तर्दृष्टि</td>
    <td style=" text-align: center;">1</td>
  </tr>
  
  <tr style="">
    <td style=" text-align: center;">2</td>
    <td style="">मनोवैज्ञानिकता (Psychosexuality) - फ्रायड की परिकल्पना</td>
    <td style=" text-align: center;">12</td>
  </tr>
  
  <tr style="">
    <td style=" text-align: center;">3</td>
    <td style="">पशु प्रवृत्ति, वास्तविकता और नैतिकता: तीन परस्पर विरोधी शक्तियों का टकराव</td>
    <td style=" text-align: center;">19</td>
  </tr>
  
  <tr style=" background-color: #f9f9f9;">
    <td style=" text-align: center;">4</td>
    <td style="">अस्वस्थ मन (The Diseased Mind)</td>
    <td style=" text-align: center;">27</td>
  </tr>
  
  <tr style="">
    <td style=" text-align: center;">5</td>
    <td style="">मनोविदलता (Schizophrenia)</td>
    <td style=" text-align: center;">36</td>
  </tr>
  
  <tr style=" background-color: #f9f9f9;">
    <td style=" text-align: center;">6</td>
    <td style="">व्यामोह के शिकार (Victims of Delusion)</td>
    <td style=" text-align: center;">42</td>
  </tr>
  
  <tr style="">
    <td style=" text-align: center;">7</td>
    <td style="">आवेशपूर्ण व्यक्तित्व (The Impulsive Personality)</td>
    <td style=" text-align: center;">51</td>
  </tr>
  
  <tr style=" background-color: #f9f9f9;">
    <td style=" text-align: center;">8</td>
    <td style="">उन्माद (Hysteria) - एक आम मनोरोग</td>
    <td style=" text-align: center;">59</td>
  </tr>
  
  <tr style="">
    <td style=" text-align: center;">9</td>
    <td style="">बाध्यता ग्रस्त व्यक्तित्व (Compulsive Personality) और नशाखोरी</td>
    <td style=" text-align: center;">69</td>
  </tr>
  
  <tr style=" background-color: #f9f9f9;">
    <td style=" text-align: center;">10</td>
    <td style="">अत्यधिक मदिरा पान और नशाखोरी - एक बहुआयामी दृष्टिकोण</td>
    <td style=" text-align: center;">75</td>
  </tr>
  
  <tr style="">
    <td style=" text-align: center;">11</td>
    <td style="">जीवन की संध्या बेला - वृद्धावस्था की समस्याएँ</td>
    <td style=" text-align: center;">87</td>
  </tr>
  
  <tr style=" background-color: #f9f9f9;">
    <td style=" text-align: center;">12</td>
    <td style="">आक्रामक प्रवृत्तियाँ और युद्ध</td>
    <td style=" text-align: center;">97</td>
  </tr>
  
  <tr style="">
    <td style=" text-align: center;">13</td>
    <td style="">मानसिक स्वास्थ्य की देखरेख और उसकी आवश्यकता</td>
    <td style=" text-align: center;">106</td>
  </tr>
  
  <tr style=" background-color: #f9f9f9;">
    <td style=" text-align: center;">14</td>
    <td style="">स्वप्न</td>
    <td style=" text-align: center;">114</td>
  </tr>
  
  <tr style="">
    <td style=" text-align: center;">15</td>
    <td style="">समायोजन (Adjustment) - एक मनोवैज्ञानिक विश्लेषण</td>
    <td style=" text-align: center;">120</td>
  </tr>
  
  <tr style=" background-color: #f9f9f9;">
    <td style=" text-align: center;">16</td>
    <td style="">समायोजन और सृजनशीलता: एक प्रयोगात्मक अध्ययन</td>
    <td style=" text-align: center;">133</td>
  </tr>
  
  <tr style="">
    <td style=" text-align: center;">17</td>
    <td style="">सृजनशीलता - एक सरसरी नज़र</td>
    <td style=" text-align: center;">141</td>
  </tr>
  
  <tr style=" background-color: #f9f9f9;">
    <td style=" text-align: center;">18</td>
    <td style="">समाजीकरण - दोराहे पर खड़ी नई पीढ़ी</td>
    <td style=" text-align: center;">149</td>
  </tr>
  
  <tr style="">
    <td style=" text-align: center;">19</td>
    <td style="">भारतीय मुस्लिम युवक और उनकी मानसिकता</td>
    <td style=" text-align: center;">157</td>
  </tr>
  
  <tr style=" background-color: #f9f9f9;">
    <td style=" text-align: center;">20</td>
    <td style="">भारतीय मुस्लिम महिलाएँ और उनका आत्म-सम्मान</td>
    <td style=" text-align: center;">165</td>
  </tr>
  
  <tr style="">
    <td style=" text-align: center;">21</td>
    <td style="">आर्थिक विकास और राष्ट्रीय एकता</td>
    <td style=" text-align: center;">173</td>
  </tr>
  
  <tr style=" background-color: #f9f9f9;">
    <td style=" text-align: center;">22</td>
    <td style="">रविवार - साधारण सा एक और दिन (एक साक्षात्कार)</td>
    <td style=" text-align: center;">180</td>
  </tr>
  
  <tr style="">
    <td style=" text-align: center;">23</td>
    <td style="">उच्च शिक्षा - एक सिंहावलोकन</td>
    <td style=" text-align: center;">184</td>
  </tr>
  
  <tr style=" background-color: #f9f9f9;">
    <td style=" text-align: center;">24</td>
    <td style="">व्यक्तिगत भेद और शिक्षा में उनका महत्व</td>
    <td style=" text-align: center;">196</td>
  </tr>
  
  <tr style="">
    <td style=" text-align: center;">25</td>
    <td style="">सामाजिक तौर पर पिछड़े बच्चों की शिक्षा</td>
    <td style=" text-align: center;">204</td>
  </tr>
  
  <tr style=" background-color: #f9f9f9;">
    <td style=" text-align: center;">26</td>
    <td style="">संतुलित व्यक्तित्व के लिए आवश्यक पाठ्येतर गतिविधियाँ</td>
    <td style=" text-align: center;">212</td>
  </tr>
  
  <tr style="">
    <td style=" text-align: center;">27</td>
    <td style="">बच्चों में सृजनशीलता का विकास</td>
    <td style=" text-align: center;">218</td>
  </tr>
  
  <tr style=" background-color: #f9f9f9;">
    <td style=" text-align: center;">28</td>
    <td style="">विद्यार्थियों में असंतोष: मनोवैज्ञानिक विश्लेषण</td>
    <td style=" text-align: center;">228</td>
  </tr>
  
  <tr style="">
    <td style=" text-align: center;">29</td>
    <td style="">प्रश्नावली: परिभाषा, डिज़ाइन तथा मानकीकरण</td>
    <td style=" text-align: center;">239</td>
  </tr>
  
  <tr style=" background-color: #f9f9f9;">
    <td style=" text-align: center;">30</td>
    <td style="">वस्तुनिष्ठ जाँच - आवश्यक परन्तु अपरिहार्य नहीं</td>
    <td style=" text-align: center;">247</td>
  </tr>
  
  <tr style="">
    <td style=" text-align: center;">31</td>
    <td style="">दूर-शिक्षा - एक आधुनिक सुविधा</td>
    <td style=" text-align: center;">251</td>
  </tr>
  
  <tr style=" background-color: #f9f9f9;">
    <td style=" text-align: center;">32</td>
    <td style="">बच्चों की शिक्षा एवं प्रशिक्षण (परिशिष्ट)</td>
    <td style=" text-align: center;">261</td>
  </tr>
  
  <tr style="">
    <td style=" text-align: center;">33</td>
    <td style="">बच्चों के विकास में प्रशिक्षण (परिशिष्ट)</td>
    <td style=" text-align: center;">261</td>
  </tr>
  
  <tr style=" background-color: #f9f9f9;">
    <td style=" text-align: center;">34</td>
    <td style="">बच्चों के विकास में बड़ों की भूमिका (परिशिष्ट)</td>
    <td style=" text-align: center;">270</td>
  </tr>
  
  <tr style="background-color: #f9f9f9;">
    <td style=" text-align: center;">35</td>
    <td style="">मनोग्रस्त माता-पिता (परिशिष्ट)</td>
    <td style=" text-align: center;">279</td>
  </tr>
  </tbody>
  </table>
  </div>
  
  <hr style="page-break-after: always;" />
  
  

<hr style="page-break-after: always;" />

`,
  },
  {
    slug: 'preface',
    name: 'प्राक्कथन (Preface)',
    markdown: `
<div style="height: 100vh; background-image: url('https://images.unsplash.com/photo-1712145176570-6cb1d98a126a?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8d2hpdGUlMjBwYXBlciUyMHRleHR1cmV8ZW58MHx8MHx8fDA%3D'); background-size: cover; padding: 80px; color: black; font-size: 24px; line-height: 1.8;">

<h1 style="text-align: center; font-size: 40px; margin-bottom: 40px;">प्राक्कथन</h1>

<p>प्रस्तुत पुस्तक “हमारा व्यवहार - एक मनोवैज्ञानिक एवं सामाजिक विश्लेषण” प्रो. शमशाद हुसैन के 34 आलेखों का संकलन है जो विभिन्न संकलितों में प्रस्तुत किये गये और शोध पत्रिकाओं एवं समाचार पत्रों में प्रकाशित हुए हैं। मूलतः यह संग्रह अंग्रेजी भाषा में “Understanding Human Behaviour” के नाम से 1998 में प्रकाशित हुआ था उस समय इसमें 31 आलेख थे। इसकी उपयोगिता एवं लोकप्रियता को देखते हुए इसका उर्दू अनुवाद खुदाबख्श लाइब्रेरी ने 2000 ई. में प्रकाशित किया था तब इसमें एक नया आलेख “बच्चों की शिक्षा एवं प्रशिक्षण” जोड़ा गया था। अब इसका हिन्दी अनुवाद भी लाइब्रेरी द्वारा प्रकाशित किया जा रहा है, जिसमें पुनः दो नये आलेख बढ़ाए गये हैं। इस संवर्द्धित संस्करण से अधिक से अधिक संख्या में पाठक लाभान्वित हो सकें यह हमारा उद्देश्य है। यह एक महत्वपूर्ण संयोग है कि उर्दू और हिन्दी अनुवाद दोनों ही श्रीमती ज़किया मशहदी द्वारा किया गया है, जो सिर्फ एक विख्यात लेखिका और अनुवादक नहीं बल्कि मनोविज्ञान की अध्यापिका भी रही हैं और विषय एवं भाषा दोनों की गहराइयों को समझते हुए उन्होंने मनोवैज्ञानिक विषयों पर आधारित इन विविध आलेखों का सहज हिन्दी में सुवाच्य अनुवाद किया है।</p>

<!-- पूरा टेक्स्ट मूल से कॉपी करें या अपनी जरूरत अनुसार बढ़ाएं -->

</div>

<hr style="page-break-after: always;" />

`,
  },  {
    slug: 'chapter-1',
    name: 'अध्याय १ (Chapter 2)',
    markdown: `
# हमारा व्यवहार – एक अन्तदृष्टि

हमारे व्यवहार अर्थात् मानव व्यवहार को समझना अत्यधिक दुष्कर कार्य है। इसके लिए सही एवं वैज्ञानिक सूझ बूझ ही नहीं बल्कि तार्किक दृष्टिकोण भी आवश्यक है। मानव मन अपने आपको व्यवहार में प्रकट करता है परन्तु प्रायः लोग गलती यह करते हैं कि मनुष्यों को सामाजिक, राजनैतिक, आर्थिक या धार्मिक जैसे वर्गों में बांट देते हैं और फिर जीवन के इन आयामों से सम्बंध रखने वाले व्यवहार की व्याख्या सीमित और पूर्व निर्धारित दृष्टिकोण के अर्न्तगत करते हैं। व्यवहार वादी वैज्ञानिकों ने दूसरों के नज़रियों की अनदेखी करके, मानव व्यवहार का विश्लेषण केवल अपने सिद्धान्तों के अनुसार करने का प्रयास किया है। कभी कभी तो एक ही विषय में व्यवहार को अलग अलग चौखटों में रखकर उसका अध्ययन किया जाता है जबकि व्यक्ति को ऐसी सम्पूर्ण इकाई के रूप में देखा जाना चाहिए जो विभिन्न जकड़बन्दियों में रहकर जीवन के साथ समायोजन करने के लिए सतत् प्रयास करता रहता है। मानव व्यवहार को जबतक हम जैविक, मनोवैज्ञानिक और सामाजिक - सांस्कृतिक, परिप्रेक्ष्य में नहीं देखेंगे, उसे समझ पाना कठिन होगा। उदाहरण के तौर पर आप यहाँ व्यक्तित्व के विकारों (Personality disorders) को लीजिए। इसकी विभिन्न किस्मों की जड़ में जो कारण निहित होते हैं उनमें एक ओर जैविक विकार, अनुवांशिक विशेषताएं, रसायनिक और एन्डोक्राइन ग्रन्थियों के स्राव का असंतुलन और दूसरी ओर मानसिक गत्यात्मक शक्तियाँ (Psychodynamics) शामिल हैं। मानसिक गत्यात्मक शक्तियों के अन्तर्गत अचेतन मन में उपस्थित अभिप्रेरणाएं, त्रुटिपूर्ण अधिगम और संज्ञान तथा प्रत्यक्षण के दोष आते हैं। इतना भी पर्याप्त नहीं है। इनके अतिरिक्त हमें सामाजिक सांस्कृतिक परिवेश को भी देखना होगा

जो एक अत्यंत प्रभावशाली कारक है। उदाहरण के तौर पर विकारग्रस्त व्यक्ति के परिवार में कैसा वातावरण था? उसे किस प्रकार के नैतिक मूल्य प्राप्त हुए? जीवन स्तर कैसा था? किन परम्पराओं के बीच उसका लालन पालन हुआ? अगर हम व्यवहार को अलग अलग चौखटों में रखकर उसका अध्ययन करेंगे तो वैज्ञानिक दृष्टिकोण से उसकी व्याख्या नहीं कर सकेंगे। मनोविज्ञान की विभिन्न शाखाओं में भी मानव व्यवहार की व्याख्या के लिए भिन्न भिन्न नज़रियों का सहारा लिया जाता है। यह नज़रिए विभिन्न प्रकार के प्रेक्षणों, चिन्तन और शोध कार्यों के परिणाम स्वरूप सामने आए हैं। उदाहरण के तौर पर स्वप्न को लीजिए। फ्रायड स्वप्नों की व्याख्या शैशव काल में दबाई गई यौन इच्छा और हिंसात्ममक प्रवृत्तियों के आधार पर करता है जबकि एक और मनोवैज्ञानिक एडलर जीवन शैली और हीन भावना को स्वप्नों को कारण कहता है। एक तीसरे प्रसिद्ध व्यक्ति युंग का कहना है कि स्वप्नों द्वारा लोग अपनी वर्तमान समस्याओं का हल ढूढ़ने का प्रयास करते हैं।

दूसरे उदाहरण के रूप में आप आतंकवाद को लीजिए। इसके लिए कुछ मनोवैज्ञानिकों का मानना है कि आतंकवाद मानव स्वभाव में निहित आक्रमकता की अभिव्यक्ति का एक रूप है। कुछ लोग इसे अस्वस्थ सामाजिक, आर्थिक एवं भावात्मक परिस्थितियों की उपज बताते हैं। वैज्ञानिकों का एक समूह ऐसा भी है जो परम अहम् (super ego) की असफलता और नैतिक मूल्यों पर पशु प्रवृत्तियों के हावी हो जाने को आतंकवाद की बुनियाद मानता है। फिर कुछ व्यक्ति ऐसे भी हैं जो अस्मिता की पहचान और व्यक्ति की क्षमताओं को सही दिशा न मिल पाने की स्थिति को आतंकवाद की जननी मानते हैं। कदाचित सामाजिक मान्यताओं को व्यक्तित्व में भली भांति आत्मसात नहीं किया जासका होगा या नवयुवकों की उर्जा का सही उपयोग नहीं हो सका होगा; उसे रचनात्मक कार्यों में नहीं लगाया गया होगा इसलिए वह ऊर्जा आतंकवाद की ओर चली गई। व्यवहार के इस रूप की व्याख्या

<hr style="page-break-after: always;" />

`,
  },
  {
    slug: 'chapter-2',
    name: 'अध्याय २ (Chapter 2)',
    markdown: `
# मनोलैंगिकता (Psycho-sexuality)
### फ्रायड की परिकल्पना
विश्व प्रसिद्ध मनोविश्लेषणवादी मनोवैज्ञानिक सिग्मंड फ्रायड ने मनोविज्ञान के समक्ष कुछ बड़े क्रान्तिकारी विचार रखे। उसका मानना था कि यौन इच्छा किशोरावस्था में उत्पन्न नहीं होती बल्कि वह बच्चों में भी मौजूद होती है भले ही उसका स्वरूप बड़ों की अपेक्षा कुठ भिन्नता लिए हुए हो। यह इच्छा बाल्यकाल से ही हमारे व्यवहार की उत्पत्ति और नियंत्रण का कारण बनती है। उसने यहाँ तक कहा कि बच्चे अपने जीवन के प्रांरभिक वर्षों में अपने माता पिता से मनोलैंगिक सम्बंधों द्वारा जुड़े हुए होते हैं। अपने इन अनूठे और अपरम्परागत विचारों के लिए उसे चारों ओर से कटु आलोचना का सामना करना पड़ा परन्तु उसका मनोविश्लेषण का सिद्धान्त इन्हीं विचारों पर आधारित रहा। इन्हीं विचारों के अन्तर्गत उसने एडिपस और एलेक्ट्रा गुत्थियों (complexes) की परिकल्पना दी। आज भी कुछ लोग फ्रायड पर यौन सम्बंधों व यौनिच्छा पर अनावश्यक बल देने और अशलीलता को बढ़ावा देने का दोषारोपण करते हैं। परन्तु वह एक ऐसा महान मनोवैज्ञानिक है जिसे सही तौर पर समझा नहीं गया। लोगों ने यौनिच्छा और मनोलैंगिकता पर उसके विचारों की गलत व्याख्या की। जबकि उसके विचारों को समझने के लिए गहराई में जाकर उनका अध्ययन करना जरूरी है। सरसरी तौर पर नज़र डालने से उन्हें सही परिप्रेक्ष्य में नहीं समझा जा सकेगा। इसके अलावा यदि फ्रायड को समझना हो तो उसकी मौलिक रचनाओं या उनके प्रमाणिक अनुवादों को पढ़ना होगा। कुछ उदाहरण या दूसरों द्वारा की गई व्याख्याओं को पढ़ लेने से फ्रायड को समझ पाना संभव नहीं है। समय के साथ जब लोग उसके विचारों से ज़्यादा अच्छी तरह अवगत हुए तो उसे संसार के अग्रगणी वैज्ञानिकों का समकक्ष माना गया भले ही उसके विचार पूर्ण रूप से स्वीकार न किए गए हों। कुछ दिन बाद फ्रायड के यौनइच्छा और आक्रमकता पर (aggression) आधारित सिद्धान्तों को मानव व्यवहार के विश्लेषण में काफी महत्व दिया गया। यहाँ हम यह देखेंगे कि मनोलैंगिकता से फ्रायड का क्या मतलब है।

आम लोग यौन सम्बंधों को दो व्यक्तियों के बीच के शरीरिक सम्बन्धों (या उनकी इच्छा) तक सीमित रखते हैं। फ्रायड का सिद्धान्त उन तक सीमित नहीं है। उसने मानव व्यक्तित्व की व्याख्या अचेतन मन, जीवन एवं मृत्यु की मूल प्रवृत्तियों (life and death instincts) और आक्रमकता (aggression) की परिकल्पना के आधार पर की। उसने लिबिडो (Libido) का भी सहारा लिया और व्यक्तित्व के विशलेषण में खुल कर इस परिकल्पना का प्रयोग किया। लिबिडो एक मनः ऊर्जा (Psychic energy) है जो यौन मनोवृत्ति से जुड़ी हुई है लेकिन मनोविशलेषण में लिबिडो केवल यौन मनोवृत्तियों के साथ ही नहीं, बल्कि अहम् (ego) से भी जोड़ी जाती है यह शब्द एक मनोशरीरिक शक्ति का द्योतक है ऐसी शक्ति जो यौनिच्छा के शारीरिक और मानसिक दोनों पहलुओं को व्यक्त करती हो। यह नग्न यौन भी है और यौन सम्बंधों की मानसिक इच्छा भी। लेकिन यह सीमित शक्ति नहीं है। यह आगे बढ़कर पूरी मानसिक ऊर्जा बन जाती है। फ्रायड ने इसे मानव व्यवहार के बहुत से ऐसे पहलुओं की व्याख्या के लिए इस्तेमाल किया जो आमतौर पर यौन व्यवहार की आम परिभाषा की सीमा में नहीं आते। स्वंय अपने आप से प्यार, माँ का बच्चे के प्रति प्यार, धार्मिक व्यक्तियों के प्रति श्रद्धा एवं प्यार और कोई भी ऐसा प्यार या काम जो आनन्द-दायक हो यौनिच्छा का वृहद् स्वरूप है। आगे चलकर फ्रायड ने अपनी इस परिकल्पना में कुछ परिवर्तन करके इसे और भी वृहद् बना दिया। इस बृहतर परिकल्पना में लिबिडो को जिजीविषा (life instinct) कहा गया अब इसमें आत्म संरक्षण, स्वप्रेम, परिजन प्रेम और अपनी क्षमताओं के विकास द्वारा आत्म विकास शामिल कर लिए गए। परन्तु जिजीविषा के साथ एक विपरीत रूझान भी मौजूद होता है वह है आत्म विनाश और पर विनाश की इच्छा। विपरीत दिशा में चलने वाली, संरक्षण और विनाश की यह मूल प्रवृत्तियाँ साथ साथ मौजूद रहती और व्यवहार को प्रभावित करती हैं।

### जीवन मूलप्रवृत्ति (Life instinct)

अभी हम ने लिबिडो में निहित ऊर्जा के बारे में जो कुछ कहा आइए उसकी रौशनी में फ्रायड की मनोलैंगिकता की परिकल्पना को समझने का प्रयास करें। फ्रायड के अनुसार यौनिच्छा का स्वरूप पूर्णतया शरीरिक नहीं है। इसी तरह यौन सुख भी केवल यौन कीड़ा से नहीं मिलता। शरीर के सरल से स्पर्श से भी सुख मिल सकता है। मानसिक सुख भी यौन सुख का एक रूप हो सकता है। फ्रायड ने मनोलैंगिकता जैसे पारिभाषिक शब्द का प्रयोग किया जो स्वंय उसके सिद्धान्त को स्पष्ट करता है। फ्रायड ने मनोलैंगिक विकास के विभिन्न चरण निर्धारित किए। (यह और बात है कि स्वंय फ्रायड के साथियों युग और एडलर ने उन्हें स्वीकार नहीं किया और फ्रायड की कड़ी आलोचना की) उसके अनुसार मानव व्यक्तित्व जन्म के समय से ही विकास के कुछ निर्धारित चरणों से गुज़रता है और एक बच्चे का बुनियादी व्यक्तित्व उसके पाँचवें या छठे वर्ष के समाप्त होते होते बन जाता है। चूँकि यौन प्ररणेद (sex drive) जीवन मूल प्रवृत्ति का इतना महत्वपूर्ण अंग है इसलिए बच्चे में लिबिडो का विकास भी अत्यंत महत्वपूर्ण प्रक्रिया है। फ्रायड का बाल लैंगिकता (infantile sexuality) का सिद्धान्त इसी विचार पर आधारित हैं। नवजात शिशु में लिबिडो स्पष्ट नहीं होती न किसी अंग विशेष से सम्बद्ध होती है। हाँ उसकी यह ऊर्जा कुछ आनन्द मंडलों (erotic zones) में दिखाई देती है।

विकास के चरणों में फ्रायड मुख, गुदा, लिंग, सुषुप्त और अंत में जननांगों की अवस्थाओं का वर्णन करता है। विकास की इन अवस्थाओं में से हर अवस्था में बच्चा अपने शरीर के अंग विशेष से जुड़ी गतिविधियों के द्वारा यौन सुख प्राप्त करता है।

### मनोलैंगिक विकास के विभिन्न चरण
मुखावस्था में जो प्रारंभिक शैशव काल की विशेषता है, नन्हें शिशु के लिए केन्द्र बिन्दु उसका मुख होता है जिसपर उसका जीवन निर्भर होता है। मुख द्वारा ही वह दूध को चूसकर पीता और भूख के शान्त होने का सुख पाता है। यह अवस्था दो उपचरणों में विभाजित है अर्थात चूसना और काटना। पहले उपचरण में वह चूसकर अपना भोजन पाता है। अधिकांश शिशु अंगूठा या कुछ और वस्तु मुँह में आ जाने पर उसे भी चूसने लगते हैं। दूसरे उपचरण में शिशु काटने भी लगता है। इसके लिए दांत निकलना जरूरी नहीं; वह अपने मसूड़ों को दबा कर ही काटने लगता है। माँ के स्तन के प्रति आक्रमक रूझान अब दूसरी वस्तुओं पर केन्द्रित हो जाते हैं।
दूसरा चरण गुदावस्था कहलाता है। इसके भी दो उपचरण हैं :
परित्यागात्मक और धारणात्मक विकास का यह चरण जीवन के दूसरे वर्ष में आरंभ होता है। बच्चे को गुदा द्वार से सुख मिलता है। पहले उपचरण में वह जब मल मूत्र त्याग करता है तो उसे शरीरिक सुख प्राप्त होता है। माँ या परिवार के दूसरे बड़े उसे मल-मूत्र त्याग से सम्बन्धित प्रशिक्षण देते अर्थात सही स्थान पर, सही स्थिति में मूल-मूत्र त्याग करना सिखाते हैं तो बच्चा शरीर से निष्कासित होने वाले इन बेकार पदार्थों को मूल्यावान समझने लगता है और अब उसे इन्हें रोक कर रखने में शारीरिक आनन्द मिलता है। इसी अवस्था में बच्चों को अपने बड़ों के साथ द्वंद का एहसास भी होता है इसलिए कि वह उसे मल-मूत्र पर नियंत्रण पाने की शिक्षा देते हैं। बच्चेपर जब चाहे, जहाँ चाहे मल-मूत्र त्याग करने की आदत को छोड़ने के लिए दबाव डाला जाता है। यह अवस्था गुदावस्था इसलिए कहलाती है कि इस समय मलद्वार (गुदा) में होने वाली संवेदनाएँ बच्चे के लिए विकार उत्पन्न करता है। इन तीनों शक्तियों के बीच चलने वाला द्वंद अचेतन मन में चलता है। इस द्वंद का समाधान भी अचेतन स्तर पर ही होता है। मनोविश्लेषण विशेषज्ञ सुप्रसिद्ध मनोवैज्ञानिक फ्रायड ने अचेतन अभिप्रेरणाओं की जड़ें शैशवकालीन कामुकता और आक्रामक रूझानों के दमन में तलाश की हैं। यह प्रवृत्तियाँ दमन की प्रक्रिया द्वारा अचेतन मन में ढकेल दी जाती और वहाँ रहकर व्यवहार को नियंत्रित करती रहती है।

आइए हम मानव व्यवहार के गत्यात्मक पहलू की रोचक विशेषताओं को देखें और वह समझने की कोशिश करें कि यह इदम, अहम् और अपरा अहम की परस्पर विरोधी अभियाचनाओं पर किस प्रकार आधारित होती हैं। इदम् जीवन की बुनियादी शक्ति है। यह जीवन के प्रारंभ से ही नवजात शिशु में मौजूद होती है। यह आनन्द के सिद्धान्त (pleasure principle) पर आधारित होती है। इसकी माँग होती है कि बच्चा वास्तविकता या नैतिकता का ध्यान दिए बिना अपनी इच्छाओं को पूरा करे। इस प्रकार इदम् से उठने वाले आवेग इच्छाओं की पूर्ति के इर्दगिर्द घूमते हैं। बच्चा अपनी इच्छाओं की संतुष्टि के लिए न तो आसपास के लोगों का ध्यान रखता है न ही स्थान और समय उसके लिए कोई महत्व रखते हैं। छोटे बच्चों में इदम अपने नग्न रूप में दिखाई देती है।

एक उदाहरण लीजिएः एक बच्चा किसी दूसरे बच्चे का खिलौना लेना चाहता है। वह आगे बढ़कर उसे झपट लेता है, बिना यह सोचे समझे कि उसका वह व्यवहार सामाजिक नियमों के अनुरूप नहीं है। इदम् मनुष्यों को अपनी इच्छाओं की तुरन्त पूरा कर लेने के लिए उकसाती है। यह पशु प्रवृत्तियों का भंडार घर है। इस भंडार में अत्यंत हिंसात्मक और कामुक प्रवृत्तियाँ भी होती हैं जिनपर कभी कभी प्रौढ़ व्यक्ति भी प्रतिबंध नहीं लगा पाते। सामाजिक संघर्ष, दूसरों पर हिंसात्मक हमले, यौन उत्पीड़न, बलात्कार, दंगे, नरसंहार, आतंकवाद और युद्ध यह सब मनुष्य में निहित पाश्विक

<hr style="page-break-after: always;" />

`,
  },
  {
    slug: 'chapter-3',
    name: 'अध्याय ३ (Chapter 3)',
    markdown: `

# अस्वस्थ मन (The Diseased Mind)

वर्तमान युग में सम्बन्धों में तेज़ी से आता विघटन आमतौर पर दिखाई देता है। वह व्यक्तिगत स्तर पर भी है और राष्ट्रीय स्तर पर भी। लोगों की अस्मिता और आत्म सम्मान पर संकट आया महसूस होता है। इसका कारण मुख्यतः यह है कि लोगों में व्यवहार के अस्वस्थ पैटर्न (Pattern) उत्पन्न होते और विकसित हो जाते हैं। इनसे व्यक्ति का व्यक्तित्व सुगठित नहीं रह पाता जब समाज में इस तरह के व्यक्तियों की संख्या ज़्यादा हो जाती है तो अन्तर्समूह संघर्ष (In-group conflict) का बीजारोपण होता है। आज के तकनीकी स्पर्धा भरे कमप्यूटर युग में स्वस्थ मन बनाए रखना काफी कठिन हो गया है। इस तरह तनावपूर्ण वातावरण की भी अपनी भूमिका है जिसके कारण दुशचिन्ता, असुरक्षा, आत्मविश्वास की कमी और दूसरों के प्रति आक्रमकता व द्वेष पनपटे हैं। इनके कारण एक व्यक्ति में दूसरे व्यक्तियों और फिर पूरे समाज के प्रति विशेष व्यवहार पैदा होता है।

विभिन्न शोध कर्त्ताओं के कार्यों, जिनमें लेखक भी शामिल है, से पता लगता है कि कुसमायोजन किस प्रकार पारिवारिक और सामाजिक सम्बन्धों को प्रभावित करता है। मन स्वस्थ न हो तो व्यक्ति की अहम् (self) की परिकल्पना संगठित नहीं रह जाती, विचारों में संतुलन नहीं रह पाता और परिणाम यह होता है कि पूरा व्यक्तित्व ही टूट फूट का शिकार हो जाता है। यूं तो शरीरिक बीमारियाँ भी काफी कष्टदायक होती और विकास में बाधा उत्पन्न करती हैं परन्तु मानसिक बीमारियाँ तो व्यक्ति के सर्वनाश का कारण बन जाती हैं। हमारे देश में मानसिक बीमारियों के साथ एक समस्या और भी हैं। यहाँ मनोरोगों को बदनामी का कारण समझा जाता है, उन्हें सामाजिक कलंक के रूप में लिया जाता है। फलतः उनकी चिकित्सा पर जल्दी ध्यान नहीं दिया जाता।

यहाँ अस्वस्थ मन से हमारा आशय केवल मनोरोगों से नहीं है। अस्वस्थ मन और भी कई रूपों में प्रकट होता है जैसे समाजद्रोही व्यवहार, नशाखोरी, अपराध, बलात्कार या यौन उत्पीडन के दूसरे तरीके और दूसरों को कष्ट पहुँचा कर आनन्द प्राप्त करने जैसी विकृत मानसिकता (sadism) आदि। इन सबके अतिरिक्त अस्वस्थ मन अत्यधिक उत्कृष्टता की भावना और यौन विकारों के रूप में भी प्रकट हो सकता है। मनोवैज्ञानिकों का मत है कि व्यवहार के यह सभी प्रत्यक्ष व अप्रत्यक्ष रूप अस्वस्थ मन के द्वारा संचालित होते हैं। इन्हीं में पूर्वाग्रह, जातीय संघर्ष, युद्ध और अन्तर्राष्ट्रीय द्वंद के कारण भी निहित होते हैं।

अस्वस्थ मन व्यवहार में कई लक्षण पैदा करता है। इनमें मुख्य लक्षण इस प्रकार हैं : व्यामोह (delusion) विभ्रम (Hallucinations) व्यक्ति, स्थान व समय के प्रति सजग न रह पाना, विकृत विचार, अवसाद, सेडिज़्म, विचारों की अभिव्यक्ति एवं सूझबूझ में कठिनाई और भावनाओं, अनुभवों एवं देखने में स्पष्टता की कमी। इनमें से कुछ लक्षण प्रकट हों तो उसका मतलब है कि व्यक्ति का मन-मस्तिष्क वास्तविकता के अनुरूप नहीं चल रहा है। यह उस व्यक्ति के लिए ही नहीं बल्कि समाज के लिए भी अच्छा नहीं होता। इसलिए उचित यह है कि मनोविकारों की न तो अवहेलना की जाए न उन्हें किसी प्रकार की सामाजिक बदनामी का कारण समझा जाए बल्कि शारीरिक रोगों की तरह ही उनका भी उपचार कराया जाए। मनोरोगों पर भी यह सिद्धान्त लागू होता है कि प्रारम्भिक अवस्था में निदान हो जाए तो न केवल उपचार में आसानी होती है बल्कि स्वास्थ्य लाभ जल्दी होता है।

अस्वस्थ मन से होने वाली क्षति पर विचार करने के बाद उसके दो महत्वपूर्ण पहलुओं को समझ लेना आवश्यक है। मानसिक विकारों के यह दो बड़े वर्ग हैं जिनके अन्तर्गत अधिकतर मानसिक बीमारियाँ आ जाती हैं। यह हैं मनस्ताप (Neurosis) और मनोविक्षिप्तिता (Psychosis) प्रस्तुत लेख में एक वैज्ञानिक ढाँचा प्रस्तुत किया जा रह

<hr style="page-break-after: always;" />

`,
  },
  {
    slug: 'chapter-4',
    name: 'अध्याय ४ (Chapter 4)',
    markdown: `
# अध्याय ४: चुनौतियाँ

यहां अध्याय ४ की सामग्री लिखें।

विषय से जुड़ी चुनौतियों और समाधानों पर चर्चा करें।

<hr style="page-break-after: always;" />

`,
  },
  {
    slug: 'chapter-5',
    name: 'अध्याय ५ (Chapter 5)',
    markdown: `
# अध्याय ५: निष्कर्ष

यहां अध्याय ५ की सामग्री लिखें।

पूरी पुस्तक का सारांश दें और भविष्य की दिशाओं पर विचार करें।

<hr style="page-break-after: always;" />

`,
  },
]
